import { useEffect, useState } from "react";

export default function useFetch(PARAMS: any, API: any, dependency?: any) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const fetchApi = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams(PARAMS);
      const result = await API(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response);
        setLoading(false);
        setErrorMessage("");
      } else {
        setData([]);
        setLoading(false);
        setErrorMessage(result?.data?.digitalRxStatusMessage);
      }
    } catch (err) {
      setError(true);
      setLoading(false);
      setErrorMessage("Try again after some time!");
    }
  };

  useEffect(() => {
    fetchApi();
  }, [API, ...dependency]);

  return { data, loading, error, fetchApi, errorMessage };
}
